
import { defineComponent, toRefs, reactive, onMounted, onUnmounted } from "vue";
import VueFeather from "vue-feather";
import { fetchInstallerStatus } from "@/helpers/api";
import { InstallerStatus } from "@/interfaces/InstallerStatus";

const POLL_INTERVAL_MS = 20000;

export default defineComponent({
  name: "InstallerPage",
  components: {
    VueFeather,
  },
  props: {
    aggregatorName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      status: null as InstallerStatus | null,
      error: null as string | null,
      lastChecked: null as Date | null,
    });

    const refresh = async () => {
      try {
        state.status = await fetchInstallerStatus(props.aggregatorName);
        state.error = null;
      } catch {
        state.error = "Could not reach server - retrying";
      }
      state.lastChecked = new Date();
    };

    let timer = 0;
    onMounted(() => {
      refresh();
      timer = window.setInterval(refresh, POLL_INTERVAL_MS);
    });
    onUnmounted(() => window.clearInterval(timer));

    return {
      ...toRefs(state),
    };
  },
});
